// Reveal on scroll
const revEls=document.querySelectorAll('.reveal,.reveal-l,.reveal-r');
const obs=new IntersectionObserver(entries=>{
  entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target)}})
},{threshold:.12});
revEls.forEach(el=>obs.observe(el));

// Shade gallery flips on cursor hover.
const shadeCards=document.querySelectorAll('.sg-item');
const canHover=window.matchMedia('(hover: hover) and (pointer: fine)').matches;
shadeCards.forEach(card=>{
  card.classList.remove('is-flipped');
  if(!canHover) return;
  card.addEventListener('pointerenter',()=>card.classList.add('is-flipped'));
  card.addEventListener('pointerleave',()=>card.classList.remove('is-flipped'));
  card.addEventListener('pointercancel',()=>card.classList.remove('is-flipped'));
});

// Mobile touch feedback for animated cards.
if(!canHover){
  document.querySelectorAll('.proc-item,.ing-card,.pcard,.sg-item').forEach(card=>{
    card.addEventListener('touchstart',()=>{
      card.classList.add('touch-active');
      window.setTimeout(()=>card.classList.remove('touch-active'),1300);
    },{passive:true});
  });
}

// Lipstick shade selector
const lipstickShades={
  graceful:{
    name:'Graceful',
    title:'Soft Nude Confidence.<br><em>Graceful by Nature.</em>',
    desc:'Graceful is a soft everyday nude that applies with a smooth, creamy glide and settles into a velvety matte finish within 60 seconds. Transfer-resistant once set, yet comfortable all day.',
    meta1:'Soft nude tone',
    meta2:'Everyday comfort',
    meta3:'Vegan & Cruelty-free',
    cta:'Shop Graceful — ₹999',
    main:'assets/products/graceful-product-user.png',
    detail:'assets/catalog/graceful-2.png',
    model:'https://vikarbeauty.com/cdn/shop/files/graceful-lipstick-model-1_a2c76376-0aa9-44d6-902b-d753818991a8.jpg?v=1773905362&width=800'
  },
  powerful:{
    name:'Powerful',
    title:'Bold Warm Colour.<br><em>Power in One Swipe.</em>',
    desc:'Powerful brings a confident warm tone with rich colour payoff and the same creamy-to-matte Velvet Era feel. It is made for days when your lip colour should lead the look.',
    meta1:'Bold warm tone',
    meta2:'Rich payoff',
    meta3:'Vegan & Cruelty-free',
    cta:'Shop Powerful — ₹999',
    main:'assets/products/velvet-lipstick-secondary.png',
    detail:'assets/catalog/powerful-2.png',
    model:'https://vikarbeauty.com/cdn/shop/files/powerful-lipstick-model-1.jpg?v=1774614651&width=800'
  },
  rare:{
    name:'Rare',
    title:'Refined Rose Depth.<br><em>Rare for a Reason.</em>',
    desc:'Rare is a refined rose shade with quiet depth, made to feel polished without looking too loud. It glides on creamy, sets velvety, and keeps the finish soft.',
    meta1:'Refined rose tone',
    meta2:'Velvet matte finish',
    meta3:'Vegan & Cruelty-free',
    cta:'Shop Rare — ₹999',
    main:'assets/catalog/rare-1.png',
    detail:'assets/catalog/rare-2.png',
    model:'https://vikarbeauty.com/cdn/shop/files/rare-lipstick-model-1.jpg?v=1774614651&width=800'
  },
  timeless:{
    name:'Timeless',
    title:'Classic Neutral Beauty.<br><em>Always in Your Era.</em>',
    desc:'Timeless is a classic neutral made for polished days, clean looks, and effortless touch-ups. It gives balanced colour with a comfortable velvety matte finish.',
    meta1:'Classic neutral',
    meta2:'Polished wear',
    meta3:'Vegan & Cruelty-free',
    cta:'Shop Timeless — ₹999',
    main:'assets/catalog/timeless-1.png',
    detail:'assets/catalog/timeless-2.png',
    model:'https://vikarbeauty.com/cdn/shop/files/timeless-lipstick-model-1.jpg?v=1774614651&width=800'
  },
  worthy:{
    name:'Worthy',
    title:'Soft Berry Nude.<br><em>Made to Be Seen.</em>',
    desc:'Worthy is a graceful berry nude with soft presence, perfect when you want colour that feels romantic but still wearable. The creamy application settles into a smooth matte veil.',
    meta1:'Berry nude tone',
    meta2:'Smooth matte veil',
    meta3:'Vegan & Cruelty-free',
    cta:'Shop Worthy — ₹999',
    main:'assets/catalog/worthy-1.png',
    detail:'assets/catalog/worthy-2.png',
    model:'https://vikarbeauty.com/cdn/shop/files/worthy-lipstick-model-1.jpg?v=1774614651&width=800'
  },
  unstoppable:{
    name:'Unstoppable',
    title:'Statement Velvet Colour.<br><em>Unstoppable Energy.</em>',
    desc:'Unstoppable is the statement shade of the Velvet Era family, created for high-impact colour with a soft, comfortable finish that still feels easy to wear.',
    meta1:'Statement shade',
    meta2:'High-impact colour',
    meta3:'Vegan & Cruelty-free',
    cta:'Shop Unstoppable — ₹999',
    main:'assets/products/unstoppable-product-user.png',
    detail:'assets/catalog/unstoppable-2.png',
    model:'https://vikarbeauty.com/cdn/shop/files/unstoppable-lipstick-model-1.jpg?v=1774441601&width=800'
  }
};
const lipstickFallback=lipstickShades.graceful.main;
function updateContent(prefix,shade){
  ['title','desc','meta1','meta2','meta3','cta'].forEach(key=>{
    const el=document.querySelector(`[data-${prefix}-content="${key}"]`);
    if(!el || !shade[key]) return;
    if(key==='title') el.innerHTML=shade[key];
    else el.textContent=shade[key];
  });
}
document.querySelectorAll('[data-lipstick-shades] .shade-chip').forEach(chip=>{
  const selectLipstick=()=>{
    const shade=lipstickShades[chip.dataset.shade];
    if(!shade) return;
    document.querySelectorAll('[data-lipstick-shades] .shade-chip').forEach(item=>item.classList.remove('active'));
    chip.classList.add('active');
    updateContent('lipstick',shade);
    const cta=document.querySelector('[data-lipstick-content="cta"]');
    if(cta) cta.href=`product-${chip.dataset.shade}.html`;
    ['main','detail','model'].forEach(type=>{
      const img=document.querySelector(`[data-lipstick-image="${type}"]`);
      if(!img) return;
      img.classList.add('is-changing');
      const next=shade[type]||lipstickFallback;
      const label=type==='model' ? `${shade.name} on model` : type==='detail' ? `${shade.name} swatch` : `Velvet Era Lipstick - ${shade.name}`;
      const finish=()=>img.classList.remove('is-changing');
      img.onload=finish;
      img.onerror=()=>{img.onerror=null;img.src=lipstickFallback;finish()};
      img.alt=label;
      img.src=next;
      if(img.complete) requestAnimationFrame(finish);
    });
  };
  chip.addEventListener('click',selectLipstick);
  chip.addEventListener('touchend',event=>{event.preventDefault();selectLipstick()},{passive:false});
});

// Blush shade selector
const blushShades={
  glowup:{
    name:"It's Giving Glow Up",
    title:'Fresh Colour Lift.<br><em>Glow Up Instantly.</em>',
    desc:'Glow Up gives a fresh, natural-looking flush with ultra-finely milled pigments that blend effortlessly into the skin. Buildable coverage lets you keep it soft or layer it brighter.',
    meta1:'Fresh glow finish',
    meta2:'Buildable coverage',
    meta3:'Vegan & Cruelty-free',
    cta:'Shop Glow Up — ₹799',
    main:'assets/catalog/glowup-3.png',
    detail:'assets/catalog/glowup-2.png',
    model:'https://vikarbeauty.com/cdn/shop/files/glowup-blush-model-1.jpg?v=1774614956&width=800'
  },
  goldenhour:{
    name:"It's Giving Grace",
    title:'Graceful Soft Pink.<br><em>A Gentle Glow.</em>',
    desc:"It's Giving Grace adds a delicate pink flush with a smooth, buildable feel. It is made for soft, graceful colour that looks fresh and effortless.",
    meta1:'Soft graceful pink',
    meta2:'Smooth buildable glow',
    meta3:'Vegan & Cruelty-free',
    cta:'Shop Grace — ₹799',
    main:'assets/catalog/grace-3.png',
    detail:'assets/catalog/grace-2.png',
    model:'https://vikarbeauty.com/cdn/shop/files/glowup-blush-model-1.jpg?v=1774614956&width=800'
  },
  rosebloom:{
    name:"It's Giving Power",
    title:'Confident Berry Pink.<br><em>Power on the Cheeks.</em>',
    desc:"It's Giving Power gives a stronger berry-pink flush that can be worn softly or built up for a confident cheek moment.",
    meta1:'Confident berry pink',
    meta2:'Buildable impact',
    meta3:'Vegan & Cruelty-free',
    cta:'Shop Power — ₹799',
    main:'assets/catalog/blushpower-3.png',
    detail:'assets/catalog/blushpower-2.png',
    model:'https://vikarbeauty.com/cdn/shop/files/glowup-blush-model-1.jpg?v=1774614956&width=800'
  },
  sunkiss:{
    name:"It's Giving Sass",
    title:'Playful Rosy Pop.<br><em>Sass in Colour.</em>',
    desc:"It's Giving Sass brings a playful rosy pop to the cheeks with a smooth texture that keeps the colour polished and easy to blend.",
    meta1:'Playful rosy pop',
    meta2:'Expressive flush',
    meta3:'Vegan & Cruelty-free',
    cta:'Shop Sass — ₹799',
    main:'assets/catalog/sass-3.png',
    detail:'assets/catalog/sass-2.png',
    model:'https://vikarbeauty.com/cdn/shop/files/glowup-blush-model-1.jpg?v=1774614956&width=800'
  },
  coralbliss:{
    name:"It's Giving Warmth",
    title:'Warm Terracotta Glow.<br><em>Soft Warmth.</em>',
    desc:"It's Giving Warmth brings a sun-kissed terracotta glow that warms the complexion while keeping the finish smooth and skin-like.",
    meta1:'Warm terracotta glow',
    meta2:'Sun-kissed finish',
    meta3:'Vegan & Cruelty-free',
    cta:'Shop Warmth — ₹799',
    main:'assets/catalog/warmth-3.png',
    detail:'assets/catalog/warmth-2.png',
    model:'https://vikarbeauty.com/cdn/shop/files/glowup-blush-model-1.jpg?v=1774614956&width=800'
  }
};
const blushFallback=blushShades.glowup.main;
document.querySelectorAll('[data-blush-shades] .shade-chip').forEach(chip=>{
  const selectBlush=()=>{
    const shade=blushShades[chip.dataset.shade];
    if(!shade) return;
    document.querySelectorAll('[data-blush-shades] .shade-chip').forEach(item=>item.classList.remove('active'));
    chip.classList.add('active');
    updateContent('blush',shade);
    const cta=document.querySelector('[data-blush-content="cta"]');
    if(cta) cta.href=`product-${chip.dataset.shade}.html`;
    ['main','detail','model'].forEach(type=>{
      const img=document.querySelector(`[data-blush-image="${type}"]`);
      if(!img) return;
      img.classList.add('is-changing');
      const next=shade[type]||blushFallback;
      const label=type==='model' ? `${shade.name} on model` : type==='detail' ? `${shade.name} blush and swatch` : `${shade.name} blush swatch`;
      const finish=()=>img.classList.remove('is-changing');
      img.onload=finish;
      img.onerror=()=>{img.onerror=null;img.src=blushFallback;finish()};
      img.alt=label;
      img.src=next;
      if(img.complete) requestAnimationFrame(finish);
    });
  };
  chip.addEventListener('click',selectBlush);
  chip.addEventListener('touchend',event=>{event.preventDefault();selectBlush()},{passive:false});
});

// Featured homepage image rotation
const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function swapImageSoft(img,src,alt){
  if(!img || !src || img.src===src) return;
  img.classList.add('is-changing');
  const fallback=img.src;
  window.setTimeout(()=>{
    img.src=src;
    if(alt) img.alt=alt;
    img.onerror=()=>{img.onerror=null;img.src=fallback;img.classList.remove('is-changing')};
    img.addEventListener('load',()=>img.classList.remove('is-changing'),{once:true});
  },180);
}
if(!reducedMotion){
  const featuredImagePool=[...document.querySelectorAll('.hero-bg-img img:not([data-hero-static="true"]),.bundle-right img')]
    .map(img=>[img.currentSrc||img.src,img.alt||'Vikar Beauty'])
    .filter(item=>item[0])
    .filter((item,index,self)=>self.findIndex(other=>other[0]===item[0])===index);
  const extraFeaturedImages=[
    ['https://vikarbeauty.com/cdn/shop/files/graceful.jpg?v=1772450961&width=800','Velvet Era Lipstick - Graceful'],
    ['https://vikarbeauty.com/cdn/shop/files/powerful.jpg?v=1774614651&width=800','Velvet Era Lipstick - Powerful'],
    ['https://vikarbeauty.com/cdn/shop/files/rare.jpg?v=1774614651&width=800','Velvet Era Lipstick - Rare'],
    ['https://vikarbeauty.com/cdn/shop/files/timeless.jpg?v=1774614651&width=800','Velvet Era Lipstick - Timeless'],
    ['https://vikarbeauty.com/cdn/shop/files/worthy.jpg?v=1774614651&width=800','Velvet Era Lipstick - Worthy'],
    ['https://vikarbeauty.com/cdn/shop/files/unstoppable.jpg?v=1774441601&width=800','Velvet Era Lipstick - Unstoppable'],
    ['https://vikarbeauty.com/cdn/shop/files/graceful2.jpg?v=1774442224&width=800','Velvet Era Lipstick texture'],
    ['https://vikarbeauty.com/cdn/shop/files/glow_up2_738f0777-557a-4a9f-b8a5-68a8d322d5c6.jpg?v=1774615409&width=800','Glow Era Blush'],
    ['https://vikarbeauty.com/cdn/shop/files/grace2.jpg?v=1774615409&width=800','Glow Era Blush detail'],
    ['https://vikarbeauty.com/cdn/shop/files/graceful-lipstick-model-1_a2c76376-0aa9-44d6-902b-d753818991a8.jpg?v=1773905362&width=800','Velvet Era Lipstick on model'],
    ['https://vikarbeauty.com/cdn/shop/files/glowup-blush-model-1.jpg?v=1774614956&width=800','Glow Era Blush on model']
  ];
  extraFeaturedImages.forEach(item=>{
    if(!featuredImagePool.some(existing=>existing[0]===item[0])) featuredImagePool.push(item);
  });
  let heroSetIndex=0;
  window.setInterval(()=>{
    if(document.hidden || featuredImagePool.length<3) return;
    heroSetIndex=(heroSetIndex+1)%featuredImagePool.length;
    const heroTargets=[...document.querySelectorAll('.hero-product:not([data-hero-static="true"])')];
    heroTargets.forEach((img,index)=>{
      const next=featuredImagePool[(heroSetIndex+(index*4))%featuredImagePool.length];
      swapImageSoft(img,next[0],next[1]);
    });
  },3600);

  let bundleIndex=0;
  window.setInterval(()=>{
    if(document.hidden || !featuredImagePool.length) return;
    bundleIndex=(bundleIndex+3)%featuredImagePool.length;
    const next=featuredImagePool[bundleIndex];
    swapImageSoft(document.querySelector('.bundle-right img'),next[0],next[1]);
  },4300);
}

// Editorial hero carousel
(()=>{
  const carousel=document.querySelector('.hero-carousel');
  if(!carousel) return;
  const panels=[...carousel.querySelectorAll('[data-hero-panel]')];
  const dots=[...carousel.querySelectorAll('[data-hero-dot]')];
  const imageButtons=[...carousel.querySelectorAll('[data-hero-image-next]')];
  const previous=carousel.querySelector('[data-hero-prev]');
  const next=carousel.querySelector('[data-hero-next]');
  let active=0;
  let timer=null;

  const showPanel=index=>{
    active=(index+panels.length)%panels.length;
    panels.forEach((panel,panelIndex)=>{
      const selected=panelIndex===active;
      panel.classList.toggle('is-active',selected);
      panel.setAttribute('aria-hidden',String(!selected));
    });
    dots.forEach((dot,dotIndex)=>{
      const selected=dotIndex===active;
      dot.classList.toggle('is-active',selected);
      dot.setAttribute('aria-current',String(selected));
    });
  };
  const stopAutoplay=()=>{
    if(timer) window.clearInterval(timer);
    timer=null;
  };
  const startAutoplay=()=>{
    stopAutoplay();
    if(!reducedMotion) timer=window.setInterval(()=>showPanel(active+1),5200);
  };
  const step=amount=>{
    showPanel(active+amount);
    startAutoplay();
  };

  previous.addEventListener('click',()=>step(-1));
  next.addEventListener('click',()=>step(1));
  imageButtons.forEach(button=>button.addEventListener('click',()=>step(1)));
  dots.forEach((dot,index)=>dot.addEventListener('click',()=>{
    showPanel(index);
    startAutoplay();
  }));
  carousel.addEventListener('mouseenter',stopAutoplay);
  carousel.addEventListener('mouseleave',startAutoplay);
  carousel.addEventListener('focusin',stopAutoplay);
  carousel.addEventListener('focusout',event=>{
    if(!carousel.contains(event.relatedTarget)) startAutoplay();
  });
  document.addEventListener('visibilitychange',()=>document.hidden?stopAutoplay():startAutoplay());
  startAutoplay();
})();

// Mobile menu
const hamburger=document.getElementById('hamburger');
const mobileMenu=document.getElementById('mobileMenu');
hamburger.addEventListener('click',()=>{
  hamburger.classList.toggle('open');
  mobileMenu.classList.toggle('open');
  document.body.style.overflow=mobileMenu.classList.contains('open')?'hidden':'';
});
function closeMobileMenu(){
  hamburger.classList.remove('open');
  mobileMenu.classList.remove('open');
  document.body.style.overflow='';
}

// Newsletter
function handleNewsletter(){
  const input=document.getElementById('nlEmail');
  if(input.value&&input.value.includes('@')){
    document.querySelector('.nl-form').style.opacity='0.4';
    document.getElementById('nlSuccess').classList.add('show');
    if(!input.closest('form')) input.value='';
  }else{
    input.style.borderColor='var(--coral)';
    setTimeout(()=>input.style.borderColor='',1200);
  }
}
document.getElementById('nlEmail').addEventListener('keypress',e=>{if(e.key==='Enter')handleNewsletter()});
